import { api } from '../../../lib/api';

export const procedureService = {
  /**
   * Create a new procedure for a maintenance plan
   * @param {number} planId - The maintenance plan ID
   * @param {Object} procedureData - Procedure data (title, description, step_number, expected_duration, safety_notes)
   * @returns {Promise<Object>} The created procedure
   */
  async create(planId, procedureData) {
    try {
      const data = await api.post(
        `/api/maintenance/procedures/${planId}`,
        procedureData
      );
      return data;
    } catch (error) {
      console.error(`Error creating procedure for plan ${planId}:`, error);
      throw error;
    }
  },

  /**
   * List all procedures for a maintenance plan
   * @param {number} planId - The maintenance plan ID
   * @returns {Promise<Array>} Array of procedures
   */
  async getByPlan(planId) {
    try {
      const data = await api.get(`/api/maintenance/procedures/${planId}/`);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error(`Error fetching procedures for plan ${planId}:`, error);
      throw error;
    }
  },

  /**
   * Get a specific procedure by ID
   * @param {number} procedureId - The procedure ID
   * @returns {Promise<Object>} The procedure data
   */
  async getById(procedureId) {
    try {
      const data = await api.get(`/api/maintenance/procedures/${procedureId}`);
      return data || null;
    } catch (error) {
      console.error(`Error fetching procedure ${procedureId}:`, error);
      throw error;
    }
  },

  /**
   * Update an existing procedure
   * @param {number} procedureId - The procedure ID
   * @param {Object} updateData - Updated procedure data
   * @returns {Promise<Object>} The updated procedure
   */
  async update(procedureId, updateData) {
    try {
      const data = await api.put(
        `/api/maintenance/procedures/${procedureId}`,
        updateData
      );
      return data;
    } catch (error) {
      console.error(`Error updating procedure ${procedureId}:`, error);
      throw error;
    }
  },

  /**
   * Delete a procedure
   * @param {number} procedureId - The procedure ID
   * @returns {Promise<void>}
   */
  async delete(procedureId) {
    try {
      await api.delete(`/api/maintenance/procedures/${procedureId}`);
    } catch (error) {
      console.error(`Error deleting procedure ${procedureId}:`, error);
      throw error;
    }
  },
};
